import { render, staticRenderFns } from "./coupons-Items-new.vue?vue&type=template&id=58205f46&scoped=true&lang=pug&"
import script from "./coupons-Items-new.vue?vue&type=script&lang=js&"
export * from "./coupons-Items-new.vue?vue&type=script&lang=js&"
import style0 from "./coupons-Items-new.vue?vue&type=style&index=0&id=58205f46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58205f46",
  null
  
)

export default component.exports